 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","ActivityDetail":"ActivityDetail","Contest2025AildEntry~Contest2025IccEntry~MobileApply~MobileStatus":"Contest2025AildEntry~Contest2025IccEntry~MobileApply~MobileStatus","Contest2025AildEntry~Contest2025IccEntry":"Contest2025AildEntry~Contest2025IccEntry","Contest2025AildEntry":"Contest2025AildEntry","Contest2025IccEntry":"Contest2025IccEntry","Contest2025AildLogin":"Contest2025AildLogin","Contest2025IccLogin":"Contest2025IccLogin","DeviceCheck~EnvCheck~Examination~UserEnvCheck":"DeviceCheck~EnvCheck~Examination~UserEnvCheck","DeviceCheck":"DeviceCheck","EnvCheck~Examination~RoomCheck":"EnvCheck~Examination~RoomCheck","EnvCheck~Examination":"EnvCheck~Examination","EnvCheck":"EnvCheck","Examination~UserEnvCheck":"Examination~UserEnvCheck","Examination":"Examination","UserEnvCheck":"UserEnvCheck","ItemApply~SxContestApply":"ItemApply~SxContestApply","ItemApply":"ItemApply","SxContestApply":"SxContestApply","ItemDetail~SxContestDetail":"ItemDetail~SxContestDetail","ItemDetail":"ItemDetail","SxContestDetail":"SxContestDetail","ItemFaq":"ItemFaq","MediaConfig":"MediaConfig","ProgrammingTest":"ProgrammingTest","UserExcellent":"UserExcellent","UserItemDetail":"UserItemDetail","UserItemList":"UserItemList","WhyLearnProgram":"WhyLearnProgram","otherPlatform":"otherPlatform"}[chunkId]||chunkId) + "." + {"404":"6d1896e7","ActivityDetail":"3cca777f","Contest2025AildEntry~Contest2025IccEntry~MobileApply~MobileStatus":"0b878b5d","Contest2025AildEntry~Contest2025IccEntry":"ec2c0d00","Contest2025AildEntry":"00185739","Contest2025IccEntry":"16bdf1d8","Contest2025AildLogin":"df9faf6b","Contest2025IccLogin":"fb26a29e","DeviceCheck~EnvCheck~Examination~UserEnvCheck":"b4a051ff","DeviceCheck":"36055fdd","EnvCheck~Examination~RoomCheck":"7097585e","EnvCheck~Examination":"76832388","EnvCheck":"8fc47e74","Examination~UserEnvCheck":"4b817745","Examination":"ca0775b8","UserEnvCheck":"b929e97c","ItemApply~SxContestApply":"cf8b30c7","ItemApply":"3bfefd3d","SxContestApply":"1ee9747a","ItemDetail~SxContestDetail":"4b46c7e5","ItemDetail":"28110737","SxContestDetail":"9feae54e","ItemFaq":"6cde6c41","MediaConfig":"4a2a12bf","ProgrammingTest":"b330ff22","UserExcellent":"af3ff076","UserItemDetail":"de014be4","UserItemList":"ae16b4e8","WhyLearnProgram":"65836c2a","otherPlatform":"29f749ff"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"ActivityDetail":1,"Contest2025AildEntry~Contest2025IccEntry":1,"Contest2025AildEntry":1,"Contest2025IccEntry":1,"Contest2025AildLogin":1,"Contest2025IccLogin":1,"DeviceCheck":1,"EnvCheck":1,"Examination~UserEnvCheck":1,"Examination":1,"UserEnvCheck":1,"ItemApply~SxContestApply":1,"ItemApply":1,"SxContestApply":1,"ItemDetail~SxContestDetail":1,"ItemDetail":1,"SxContestDetail":1,"ItemFaq":1,"MediaConfig":1,"ProgrammingTest":1,"UserExcellent":1,"UserItemDetail":1,"UserItemList":1,"WhyLearnProgram":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","ActivityDetail":"ActivityDetail","Contest2025AildEntry~Contest2025IccEntry~MobileApply~MobileStatus":"Contest2025AildEntry~Contest2025IccEntry~MobileApply~MobileStatus","Contest2025AildEntry~Contest2025IccEntry":"Contest2025AildEntry~Contest2025IccEntry","Contest2025AildEntry":"Contest2025AildEntry","Contest2025IccEntry":"Contest2025IccEntry","Contest2025AildLogin":"Contest2025AildLogin","Contest2025IccLogin":"Contest2025IccLogin","DeviceCheck~EnvCheck~Examination~UserEnvCheck":"DeviceCheck~EnvCheck~Examination~UserEnvCheck","DeviceCheck":"DeviceCheck","EnvCheck~Examination~RoomCheck":"EnvCheck~Examination~RoomCheck","EnvCheck~Examination":"EnvCheck~Examination","EnvCheck":"EnvCheck","Examination~UserEnvCheck":"Examination~UserEnvCheck","Examination":"Examination","UserEnvCheck":"UserEnvCheck","ItemApply~SxContestApply":"ItemApply~SxContestApply","ItemApply":"ItemApply","SxContestApply":"SxContestApply","ItemDetail~SxContestDetail":"ItemDetail~SxContestDetail","ItemDetail":"ItemDetail","SxContestDetail":"SxContestDetail","ItemFaq":"ItemFaq","MediaConfig":"MediaConfig","ProgrammingTest":"ProgrammingTest","UserExcellent":"UserExcellent","UserItemDetail":"UserItemDetail","UserItemList":"UserItemList","WhyLearnProgram":"WhyLearnProgram","otherPlatform":"otherPlatform"}[chunkId]||chunkId) + "." + {"404":"9b2ad2ff","ActivityDetail":"e143f838","Contest2025AildEntry~Contest2025IccEntry~MobileApply~MobileStatus":"31d6cfe0","Contest2025AildEntry~Contest2025IccEntry":"61dccabc","Contest2025AildEntry":"c76078ae","Contest2025IccEntry":"dda2f7b4","Contest2025AildLogin":"70c69821","Contest2025IccLogin":"ea5b7e7e","DeviceCheck~EnvCheck~Examination~UserEnvCheck":"31d6cfe0","DeviceCheck":"12ed65f3","EnvCheck~Examination~RoomCheck":"31d6cfe0","EnvCheck~Examination":"31d6cfe0","EnvCheck":"f2aad051","Examination~UserEnvCheck":"1edf4ae1","Examination":"818fb0f1","UserEnvCheck":"ddb3a571","ItemApply~SxContestApply":"d28ddc76","ItemApply":"1763e3bd","SxContestApply":"50200341","ItemDetail~SxContestDetail":"4e3dc8cb","ItemDetail":"4111d4b2","SxContestDetail":"3ee70b25","ItemFaq":"c2810ea9","MediaConfig":"c2cbd40f","ProgrammingTest":"9ec51c2c","UserExcellent":"6ffe019c","UserItemDetail":"21794657","UserItemList":"199a19cc","WhyLearnProgram":"421bf3c9","otherPlatform":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://fedmarketing.htcdn-a.com/ug-fe-contest-student/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
